import { Accordion, Tmd14, Trg11, Spacer } from 'oui';
import { useEffect, useState } from 'react';
import * as S from './Accordion.styled';

interface IAccordion {
  title: any;
  content: any;
}

interface IAccordionList {
  list: IAccordion[];
  backgroundColor?: 'gray' | 'white';
}

export const AccordionList = ({
  list,
  backgroundColor = 'gray',
}: IAccordionList) => {
  const [isExpand, setExpand] = useState<boolean[]>([]);

  const onToggleExpand = (idx: number) => {
    setExpand((prev) => {
      return prev.map((v, i) => i === idx ? !v : v)
    });
  };
  useEffect(() => {
    if (list.length > 0) {
      setExpand(new Array(list.length).fill(false));
    }
  }, []);

  return (
    <>
      {list.length > 0 &&
        list.map((item: any, idx: number) => {
          return (
            <Accordion
              key={`acc_list_${idx}`}
              expend={isExpand[idx]}
              backgroundColor={backgroundColor}
              titleChildren={item.title}
              contentChildren={item.content}
              onClickTitle={() => onToggleExpand(idx)}
            />
          );
        })}
    </>
  );
};
